const QA_BENCHMARK_EMAILS: string[] = [
  "ascientifictest+9@gmail.com",
  "ernestasmazutis@gmail.com",
];

const getEnabledEmails = (): string[] => {
  return QA_BENCHMARK_EMAILS.map(email => email.trim().toLowerCase()).filter(Boolean);
};

export const isBenchmarkEnabledForCountry = (countryCode: string | undefined, email?: string): boolean => {
  const enabledEmails = getEnabledEmails();
  const normalisedEmail = email?.trim().toLowerCase();

  if (normalisedEmail && enabledEmails.includes(normalisedEmail)) {
    return true;
  }

  if (!countryCode) return false;

  const enabledCountries = process.env.REACT_APP_BENCHMARK_ENABLED_COUNTRIES;
  if (!enabledCountries) return false;

  const allowedCountries = enabledCountries.split(",").map(c => c.trim().toUpperCase());
  return allowedCountries.includes(countryCode.toUpperCase());
};